import type { FC } from 'react'

import { LoaderCircle } from '@skytech/ui'
import { useQuery } from '@tanstack/react-query'
import orderBy from 'lodash/orderBy'

import { Translation } from '@/app/translations/Translation'
import { NoResults } from '@/components/NoResults'
import { ResultCount } from '@/components/ResultCount'
import { useRenderLimit } from '@/hooks/use-render-limit'
import { DEVICE_ORDER_STATUS_ID } from '@/modules/applications/device/constants'
import deviceApplicationResources from '@/modules/applications/device/resources'

import queries from '../queries'

import DeviceApplicationListItem from './DeviceApplicationListItem'
import { getFilteredList } from './helpers'

import 'react-dropdown/style.css'

const DeviceApplicationList: FC<{
  searchFilter: string
  statusFilter: number
}> = ({ searchFilter, statusFilter }) => {
  const { data: deviceApplicationList = [], isLoading } = useQuery(
    queries.deviceApplications(),
    deviceApplicationResources.getList
  )

  const orderedList = orderBy(
    getFilteredList({ statusFilter, searchFilter, deviceApplicationList }),
    ['id'],
    ['desc']
  )

  const { visibleList, ListLoaderComponent } = useRenderLimit(orderedList, 15)

  if (isLoading) return <LoaderCircle />

  if (visibleList.length === 0)
    return (
      <NoResults>
        <Translation id="No orders found" />
      </NoResults>
    )

  return (
    <>
      <ResultCount count={orderedList.length} />
      <div className="items">
        {visibleList.map(order => (
          <DeviceApplicationListItem
            key={order.id}
            searchFilter={searchFilter}
            order={order}
            showStatus={statusFilter === DEVICE_ORDER_STATUS_ID.ALL}
          />
        ))}

        <ListLoaderComponent />
      </div>
    </>
  )
}

export default DeviceApplicationList
